export function usageBarPercent(used, cap) {
  const u = Math.max(0, Number(used) || 0);
  if (cap === "unlimited") return 0;
  if (cap == null || !Number.isFinite(Number(cap))) return 0;
  const max = Math.max(1, Number(cap));
  return Math.min(100, Math.round((u / max) * 100));
}

export function formatPlanCapLabel(cap) {
  if (cap === "unlimited") return "∞";
  if (cap == null || !Number.isFinite(Number(cap))) return "—";
  return String(cap);
}

export function findTierInCatalog(plans, planId) {
  if (planId == null || !Array.isArray(plans)) return null;
  const key = String(planId).trim().toLowerCase();
  if (!key) return null;
  return plans.find((p) => String(p.id).trim().toLowerCase() === key) ?? null;
}

export function formatMoneyFromMinorUnits(amountCents, currency) {
  const cur = String(currency ?? "cad").toUpperCase();
  const n = Number(amountCents);
  if (!Number.isFinite(n)) return "";
  return (n / 100).toLocaleString("en-CA", {
    style: "currency",
    currency: cur,
  });
}

export function yearlySavingsPercent(monthlyAmountCents, yearlyAmountCents) {
  const m = Number(monthlyAmountCents);
  const y = Number(yearlyAmountCents);
  if (!Number.isFinite(m) || !Number.isFinite(y) || m <= 0) return null;
  const full = m * 12;
  if (full <= 0) return null;
  const pct = Math.round((1 - y / full) * 100);
  return Number.isFinite(pct) ? Math.max(0, pct) : null;
}
